import * as React from 'react';
import { useAuth } from '../../../../App';
import { Modal, ModalBody, ModalSize, ModalFooter, CustomButton, ButtonType, CustomSubmitButton, Form } from 'soprasteria-ui-library';
import { OrthodonticReferralDecisionApi } from '../../../../api/OrthodonticReferralDecisionApi';
import { useHistory } from 'react-router';

interface IOrthodonticReferralShareWithJointConsultationGroupModal {
    orthodonticReferralId: number;
    changeSuccessMessage: (message: string) => void;
    getOrthodonticReferral: (id: number) => void;
    orthodonticReferralAdvancedConsultationNeedId: number;
    isConsultantCareProvider: boolean;
}

export const OrthodonticReferralShareWithJointConsultationGroupModal: React.FunctionComponent<IOrthodonticReferralShareWithJointConsultationGroupModal> = ({ orthodonticReferralId, changeSuccessMessage, getOrthodonticReferral, orthodonticReferralAdvancedConsultationNeedId, isConsultantCareProvider }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralDecisionApi(auth);
    const [isSending, setIsSending] = React.useState<boolean>(false);
    const history = useHistory();

    const shareOrthodonticReferralWithJointConsultationGroup = () => {
        setIsSending(true);

        api.shareOrthodonticReferralWithJointConsultantGroup(orthodonticReferralAdvancedConsultationNeedId, () => {
            document.getElementById("close-orthodontic-referral-share-with-joint-consultation-group-modal")?.click();
            changeSuccessMessage("Ortodontiremissen har skickats till samrådsgruppen");
            getOrthodonticReferral(orthodonticReferralId);
        }, undefined, () => {
            if (!isConsultantCareProvider) {
                history.goBack();
            }
            setIsSending(false)
        });
    }

    return (
        <>
            <Modal header="Skicka till samrådsgruppen" id="orthodontic-referral-share-with-joint-consultation-group-modal" modalSize={ModalSize.large}>
                <Form onSubmit={shareOrthodonticReferralWithJointConsultationGroup}>
                    <ModalBody>
                        <p>Är du säker på att du vill skicka ortodontiremissen till samrådsgruppen? {!isConsultantCareProvider ? "Du kommer inte längre ha tillgång till den här remissen och skickas tillbaka till föregående sida." : ""}</p>
                    </ModalBody>
                    <ModalFooter>
                        <CustomButton buttonType={ButtonType.general} buttonText="Avbryt"
                            data-dismiss="modal" id="close-orthodontic-referral-share-with-joint-consultation-group-modal" />
                        <CustomSubmitButton isLoading={isSending}>Skicka</CustomSubmitButton>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
}